import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';

const useStyles = theme => ({
    cancelButtonStyle: {
        '&:hover': {
            backkgroundColor: 'transparent'
        }
    },
    deleteButtonStyle: {
        outline: 'none',
        variant: 'contained',
        color: '#ffffff',
        fontSize: 18,
        textTransform: 'none',
        backgroundColor: '#d73b49 !important',
        outlineColor: '#d73b49 !important',
        '&:hover': {
            backgroundColor: 'transparent'
        }
    }
});

class CustomDialog extends Component {
    render() {
        const { classes } = this.props;
        return (
            <Dialog open={this.props.open} onClose={this.props.handleClose}>
                <DialogTitle>Are you sure you want to delete this data?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This will delete the data permanently. Select Delete to delete or Cancel to cancel
                        </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" disableRipple className={classes.cancelButtonStyle} onClick={this.props.handleClose}>Cancel</Button>
                    <Button disableRipple className={classes.deleteButtonStyle} onClick={this.props.handleDelete}>Delete</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(useStyles)(CustomDialog);